var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGovernmentSolid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.526367 12.3347L12.0005 6.59766L23.4746 12.3347H0.526367Z",
    fill: "#1A1E23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0126953 11.3083L11.4868 5.57129H12.5131L23.9872 11.3083L23.474 13.482H0.525833L0.0126953 11.3083ZM5.38634 11.1872H18.6135L11.9999 7.88041L5.38634 11.1872Z",
    fill: "#1A1E23"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3917 0.252052C11.5531 0.0906656 11.772 -2.76396e-08 12.0002 -3.7616e-08L16.7811 2.697e-08C17.2564 6.19521e-09 17.6416 0.385285 17.6416 0.860557L17.6416 2.58167C17.6416 2.80991 17.551 3.02879 17.3896 3.19018C17.2282 3.35157 17.0093 3.44223 16.7811 3.44223L12.8608 3.44223L12.8608 7.0757L11.1396 7.0757L11.1396 0.860558C11.1396 0.632324 11.2303 0.413437 11.3917 0.252052Z",
    fill: "#1A1E23"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.53418 11.4741H7.12382V23.2351H2.53418V11.4741ZM4.2553 13.1952V21.514H5.40271V13.1952H4.2553Z",
    fill: "#1A1E23"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70508 11.4741H14.2947V23.2351H9.70508V11.4741ZM11.4262 13.1952V21.514H12.5736V13.1952H11.4262Z",
    fill: "#1A1E23"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.877 11.4741H21.4666V23.2351H16.877V11.4741ZM18.5981 13.1952V21.514H19.7455V13.1952H18.5981Z",
    fill: "#1A1E23"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333984 21.7051L23.6647 21.7051L23.6647 23.9999L0.333984 23.9999L0.333984 21.7051Z",
    fill: "#1A1E23"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernmentSolid);
export default __webpack_public_path__ + "static/media/government-solid.8c05a1cdd39695b3bf8803af526926b6.svg";
export { ForwardRef as ReactComponent };